namespace Ir.Components.Workbook.Filters {
    interface IFiltersViewModel {
        applyFilters: DevExpress.ui.dxButton.Properties;
        showHideFilterActions: DevExpress.ui.dxButton.Properties;
        showHideFilterActionsChecked: KnockoutComputed<boolean>;
        isToolbar: KnockoutObservable<boolean>;

        activeTab: KnockoutObservable<WorkbookTab>;
        workbookFilters: KnockoutObservableArray<Filter>;

        widgetFiltersVisibility: KnockoutObservable<boolean>;
        selectedDashboardWidget: KnockoutObservable<DashboardWidget>;

        scrollViewOptions: DevExpress.ui.dxScrollView.Properties;

        workbookFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        tabFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        widgetFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;

        comparisonFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        hasComparisonFilters: KnockoutObservable<boolean>;
    }
    interface IFiltersViewModelParams {
        config: WorkbookConfig;
        isToolbar: boolean;
        element: any;
    }

    export function getViewModel(this: IFiltersViewModel, params: IFiltersViewModelParams, componentInfo) {
        let self = this;
        this.isToolbar = ko.observable(params.isToolbar);
        this.applyFilters = {
            icon: "check",
            text: "Apply Filters",
            hint: "Apply all filters",
            stylingMode: 'contained',
            type: 'danger',
            disabled: params.config.workbookHelper.applyFiltersDisabled as any,
            //width: "90%",
            elementAttr: {
                class: `apply-filter-button ${(!isTouchDevice() ? "fullWidth" : "")}`,
            },
            onClick: function () {
                params.config.filterHelper.updateFilters();
            }
        };

        this.showHideFilterActionsChecked = ko.computed(function () {
            return workbook.workbookConfig.workbookHelper.showHideFilterActions();
        });
        this.showHideFilterActions = {
            icon: "ms ir-showHideFilterActions-icon",
            hint: "Show/Hide filter actions buttons: Delete and Settings",
            stylingMode: 'contained',
            width: 26,
            elementAttr: {
                class: "showHide-filter-actions-button",
            },
            onClick: function (e) {
                workbook.workbookConfig.workbookHelper.showHideFilterActions(!workbook.workbookConfig.workbookHelper.showHideFilterActions());
                e.element.blur();//remove focus
            },
            visible: isTouchDevice()
        };

        this.workbookFilters = params.config.filters;
        this.activeTab = params.config.activeTab;

        this.widgetFiltersVisibility = ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
            return this().tabType() === TabTypeEnum.Dashboard && this().dashboard.selectedWidget() !== null;
        }, params.config.activeTab)

        this.selectedDashboardWidget = ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
            return this().tabType() === TabTypeEnum.Dashboard ? this().dashboard.selectedWidget() : null;
        }, workbook.workbookConfig.activeTab);

        this.scrollViewOptions = {
            direction: this.isToolbar() ? "horizontal" : "vertical",
            useNative: false
        }

        this.workbookFilterSection = {
            scope: ko.computed(function () {
                return ContainerScopeEnum.Workbook;
            }),
            filters: ko.computed(function () {
                return self.workbookFilters;
            }),
            isToolbar: this.isToolbar(),
            title: ko.computed(function () {
                return "Workbook";
            }),
            onOrderChanged(filters) {
                workbook.workbookConfig.workbookHelper.saveFiltersOrder(filters(), ContainerScopeEnum.Workbook);
            }
        };
        this.tabFilterSection = {
            scope: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                return this() && this().tabType() == TabTypeEnum.Dashboard ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report;
            }, this.activeTab),
            filters: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                return this() && this().filters;
            }, this.activeTab),
            isToolbar: this.isToolbar(),
            title: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                return this() && this().tabType() == TabTypeEnum.Dashboard ? "Dashboard" : "Report";
            }, this.activeTab),
            onOrderChanged(filters) {
                workbook.workbookConfig.workbookHelper.saveFiltersOrder(filters(), self.activeTab().tabType() === TabTypeEnum.Dashboard ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report);
            }
        };
        this.widgetFilterSection = {
            scope: ko.computed(function () {
                return ContainerScopeEnum.Widget;
            }),
            filters: ko.computed(function (this: KnockoutObservable<DashboardWidget>) {
                return this() && this().filters;
            }, this.selectedDashboardWidget),
            isToolbar: this.isToolbar(),
            title: ko.computed(function () {
                return "Widget";
            }),
            onOrderChanged(filters) {
                workbook.workbookConfig.workbookHelper.saveFiltersOrder(filters(), ContainerScopeEnum.Widget);
            }
        };


        this.comparisonFilterSection = {
            scope: ko.computed(function () {
                return ContainerScopeEnum.ComparisonFilter;
            }),
            comparisonFilters: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                return this() && this().reportConfig && this().reportConfig.comparisonFilters;
            }, workbook.workbookConfig.activeTabOrWidget),
            isToolbar: this.isToolbar(),
            title: ko.computed(function () {
                return "Comparison Filters";
            }),
            addClearButtonsVisible: false,
            isComparisonFilter: true,
        };
        this.hasComparisonFilters = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            return this() && this().reportConfig && this().reportConfig.comparisonFilters().length > 0;
        }, workbook.workbookConfig.activeTabOrWidget);
    }
}